import {FC} from "react";
import {useApiCall} from "../../../lib/src/api";
import {config} from "../config";
import {Flow} from "@jane/lib/src/api/repositories/flows-repository";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const DeletePlannedFlowSchedulesModal: FC<{ flow: Flow, onFinished: () => void }> = (props) => {
  const {flows} = useApiCall(config)

  const remove = async () => {
    await flows.deleteFlowSchedules(props.flow.id)
      .then(() => {
        props.onFinished?.()
      })
  }

  return <div>
    <div>Weet je zeker dat je de ongeplande flows wilt verwijderen?</div>
    <ModalFooter text={'Verwijderen'} onSubmit={remove} />
  </div>
}